import React from "react";
import AppPaymentBanner from "./AppPaymentBanner/AppPaymentBanner";
import AppOverviewWidget from "./AppOverviewWidget/AppOverviewWidget";
import KarteJaBadhteJaWiget from "./KarteJaBadhteJaWidget/KarteJaBadhteJaWidget";
import TrustWidget from "./TrustWidget/TrustWidget";
import PartnerShowcaseWidget from "./PartnerShowcaseWidget/PartnerShowcaseWidget";
import BusinessOverviewWidget from "./BusinessOverviewWidget/BusinessOverviewWidget";
import InThePressWidget from "./InThePressWidget/InThePressWidget";
import AppStatsWidget from "./AppStatsWidget/AppStatsWidget";
import SEO from "../../components/seo";

import Layout from "../../components/Layout/Layout";

import "./index.css";

class HomePage extends React.Component {
    render() {
        return (
            <Layout showFLButton={true}>
                <SEO
                    title="PhonePe • UPI • India's Payments App"
                    description="PhonePe is India's Payments App... We are revolutionizing easy cashless payments! Make lightning fast money transfers, pay your bills in a few clicks, pay easy at stores &amp; checkout faster online with PhonePe."
                    url="https://www.phonepe.com/"
                />
                <AppPaymentBanner />
                <AppOverviewWidget />
                <KarteJaBadhteJaWiget />
                <TrustWidget />
                <PartnerShowcaseWidget />
                <BusinessOverviewWidget />
                <InThePressWidget />
                <AppStatsWidget />
            </Layout>
        );
    }
}

export default HomePage;
